<template>
  <div class="bg-gray-50 py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="section-title">Nos Partenaires</h2>
        <p class="section-subtitle">
          Nous remercions nos partenaires qui nous soutiennent dans notre mission musicale
        </p>
      </div>
      
      <!-- Utilisation du composant PartnersLogos -->
      <PartnersLogos />
    </div>
  </div>
</template>

<script>
import PartnersLogos from './PartnersLogos.vue'

export default {
  name: 'SponsorsSection',
  components: {
    PartnersLogos
  }
}
</script>

<style scoped>
.section-title {
  @apply text-3xl font-bold text-gray-900 mb-4;
}

.section-subtitle {
  @apply text-lg text-gray-600 max-w-3xl mx-auto;
}
</style>